export default "__VITE_ASSET__13544893__"